const sk_SK = {
    homepage_title: 'Stiahnuť CalendarTask mobilnú verziu cez QR kód',
    homepage_slogn: 'CalendarTask mobilná verzia',
    homepage_ios_download: 'App Store v kontrole...',
    homepage_download: 'Stiahnuť',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Stiahnuť CalendarTask mobilnú verziu cez QR kód',
    phonedownload_slogan: 'Synchronizácia s PC a tabletom, poznámky kdekoľvek',
    phonedownload_send_vip: 'Nainštalujte aplikáciu a získajte VIP členstvo',
    phonedownload_screenshot: 'Snímka obrazovky',
    phodedownload_macos: 'CalendarTask verzia macOS',
    phodedownload_windows: 'CalendarTask verzia Windows',
    phodedownload_otherbutton: 'Zobraziť teraz',
    phodedownload_about: 'Kontakt',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Bez reklám',
    feature_easy: 'Mesačný pohľad, jednoduchý a ľahký',
    feature_reminder: 'Vlastné pripomenutie',
    feature_countdown: 'Odpočítavanie výročia',

    vip_task_succ: 'Úspech. Stiahnite aplikáciu na aktiváciu VIP',
    vip_task_error: 'Prijatie zlyhalo',

    group_slogn: 'Pozvánka CalendarTask tím',

    tt_title: 'CalendarTask',
    tt_share_1: 'Zdieľané s vami',
    tt_share_2: 'Rozvrh',
    tt_share_show_1: 'Naskenujte QR kód aplikáciou "CalendarTask", PC a mobil zobrazia',
    tt_share_show_2: 'rozvrh',
    tt_share_scan_1: 'Skenovať',
    tt_share_scan_2: 'aplikáciou "CalendarTask"',
    tt_share_succ: 'Synchronizácia úspešná',

    v2_copyright: 'Kontakt service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Všetky práva vyhradené.',
    v2_download_appstore: 'Stiahnuť v App Store',
    v2_download_googleplay: 'Dostupné v Google Play',

    v2_main_title: 'CalendarTask Mobilný',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobilný',
    v2_main_description: 'Hľadajte <span class="name">CalendarTask</span> v App Store alebo Google Play',
    v2_download_ios: 'Stiahnuť iOS',
    v2_download_android: 'Stiahnuť Android',
    v2_download_harmonyos: 'Stiahnuť HarmonyOS',
    v2_sync_status: 'Synchronizácia dokončená! 1 nahraté, 0 stiahnuté',
    v2_feature_title: 'Synchronizácia dát viacerých zariadení',
    v2_feature_description: 'Synchronizácia medzi mobilom, tabletom a PC'
};
export default sk_SK;
